import { c as _c } from "react/compiler-runtime";
import { VurderingIkkeAktuell } from "@/components/view/mottattVurdering/VurderingIkkeAktuell";
import { VurderingOppfylt } from "@/components/view/mottattVurdering/VurderingOppfylt";
import { VurderingUnntak } from "@/components/view/mottattVurdering/VurderingUnntak";
import type { AktivitetskravVurdering } from "@/schema/aktivitetskravVurderingSchema";
interface Props {
  vurdering: AktivitetskravVurdering;
}
export const MottattVurderingDetaljer = t0 => {
  const $ = _c(5);
  const {
    vurdering
  } = t0;
  switch (vurdering.status) {
    case "OPPFYLT":
      {
        let t1;
        if ($[0] !== vurdering) {
          t1 = <VurderingOppfylt vurdering={vurdering} />;
          $[0] = vurdering;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "UNNTAK":
      {
        let t1;
        if ($[2] !== vurdering) {
          t1 = <VurderingUnntak vurdering={vurdering} />;
          $[2] = vurdering;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "IKKE_AKTUELL":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <VurderingIkkeAktuell />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
  }
};